import { parseAppElectionId } from "./electionBehavior";

// Verified 2026 precinct redivisions. Use canonical slugs, never environment-local DB IDs.
const REDIVIDED_AREAS = new Set(["ostravajih", "plzen1"]);

export const BOUNDARY_CHANGE_NOTICE =
  "V roce 2026 se v této oblasti změnily hranice a číslování okrsků. Okrsky před a po změně nelze přímo porovnávat. Jednotlivé volební mapy a souhrny za celou oblast zůstávají dostupné.";

export function hasPrecinctBoundaryBreak(electionIdA, electionIdB) {
  const a = parseAppElectionId(electionIdA);
  const b = parseAppElectionId(electionIdB);
  if (!REDIVIDED_AREAS.has(a.area_slug) && !REDIVIDED_AREAS.has(b.area_slug)) return false;
  if (!a.year || !b.year) return true;
  return (a.year >= 2026) !== (b.year >= 2026);
}

// Keep own-map colouring, hover and detail working while preventing cross-map joins.
export function scopePrecinctPairKey(key, side, blocked) {
  if (!key) return key;
  return blocked ? `${side}:${key}` : key;
}
